var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9124 15.8475C24.5126 14.9585 24.5126 12.6571 22.9124 11.7681L3.46822 0.965773C1.74799 0.0100889 -0.309991 1.48208 0.0386245 3.41883L1.898 13.7487C1.90503 13.7878 1.90503 13.8278 1.898 13.8668L0.0386217 24.1967C-0.309992 26.1335 1.74798 27.6055 3.46822 26.6498L22.9124 15.8475ZM21.9411 13.5164C22.1697 13.6434 22.1697 13.9722 21.9411 14.0992L2.49693 24.9015C2.25118 25.038 1.95719 24.8277 2.00699 24.551L3.76077 14.8078H11.1914C11.7437 14.8078 12.1914 14.3601 12.1914 13.8078C12.1914 13.2555 11.7437 12.8078 11.1914 12.8078H3.76078L2.00699 3.06452C1.95719 2.78785 2.25118 2.57756 2.49693 2.71409L21.9411 13.5164Z",
    fill: "#339999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.06db2f2ccdb1a1d96a1e7770fb03ca79.svg";
export { ForwardRef as ReactComponent };